import { createStore, createTypedHooks } from 'easy-peasy';

import globalUtils from 'store/models/globalUtils';
import contacts from 'store/models/contacts';
import type { GlobalUtilsModel } from 'store/models/globalUtils';
import type { ContactsModel } from 'store/models/contacts';

export interface StoreModel {
  globalUtils: GlobalUtilsModel;
  contacts: ContactsModel;
}

export const model: StoreModel = {
  globalUtils,
  contacts,
};

export const store = createStore(model, {
  name: 'appStore',
  disableImmer: true,
});

export const { useStoreActions, useStoreDispatch, useStoreState, useStore } = createTypedHooks<StoreModel>();
